const colors = {
  loadingComponentColor: "#D2D2D2",
  // Structural, belonging to nobody's brand: the ink of the neutral mark shown
  // where a service has no logo of its own.
  serviceMarkColor: "#7C858F",
  // The muted ink of secondary copy on the cards. New sites read it from here
  // so the grey has one home; the older inline literals are tracked baseline.
  mutedTextColor: "#707070",
};

export default colors;
